<!-- Navigation Tabs -->
<div class="card">
	<div class="card-body bg-gray-200 px-4 py-2">
		<ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
			<li class="nav-item" *ngFor="let child of reportDataChildren">
				<a class="nav-link"
				   [class.active]="activeTab === child.path"
				   href="javascript:;"
				   (click)="setActiveTab(child.path || '')">
					{{ child.data?.navTitle }}
				</a>
			</li>
			<!-- <li class="nav-item">
				<a class="nav-link"
				   [class.active]="activeTab === 'sales'"
				   href="javascript:;"
				   (click)="setActiveTab('sales')">
					Sales
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link"
				   [class.active]="activeTab === 'pending'"
				   href="javascript:;"
				   (click)="setActiveTab('pending')">
					Pending Invoices
				</a>
			</li> -->
		</ul>
	</div>
</div>

<!-- Router Outlet for Child Components -->
<router-outlet></router-outlet>
